import styled from 'styled-components';
import { Link } from 'react-router-dom';

import {
	Body,
	BodyDesc,
	BodyFooter,
	BodyTitle,
	BodyTitleGroup,
	ForgotText,
} from './style';

const PasswordHelp = () => {
	return (
		<Body>
			<BodyTitleGroup>
				<BodyTitle>비밀번호 분실</BodyTitle>
				<BodyDesc>
					비밀번호 분실 및 로그인 관련 오류가 발생하신 경우 BOUNCE팀 김성욱 프로에게 연락
					바랍니다.
				</BodyDesc>
				<BodyDesc>메일 주소 : edwins.kim@samsung.com</BodyDesc>
			</BodyTitleGroup>

			<BodyFooter>
				<Link to="/imms/login">
					<PrevText>{'<'} 이전</PrevText>
				</Link>
			</BodyFooter>
		</Body>
	);
};

const PrevText = styled(ForgotText)`
	text-align: left;
	text-decoration: none;
`;

export default PasswordHelp;
